export default __webpack_public_path__ + "static/media/ic_lock.e6a8b7e4.svg";